module.exports = __webpack_public_path__ + "static/media/tenth_southside_school3.2a8e3018.jpg";